import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavShellService } from 'shared/domain';

import { ButtonDirective } from '../button/button.directive';
import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'common-footer',
  standalone: true,
  imports: [TranslocoPipe, MatIconModule, IconDirective, ButtonDirective],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  private navShellService = inject(NavShellService);

  protected isMenuOpen = this.navShellService.sideNavState;

  protected handleMobileMenuClick() {
    if (this.isMenuOpen()) {
      this.navShellService.close();
    } else {
      this.navShellService.open();
    }
  }
}
